/**
 * Scroll to a section of the page
 * @param id - The id of the section to scroll to
 * @param options - The options to pass to the scrollIntoView method
 */

export const scrollToContent = (id: string, options?: ScrollIntoViewOptions) => {
  const element = document.getElementById(id);
  element?.scrollIntoView(options ?? { behavior: "smooth", block: "start" });
};
